var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.868 21.1314C38.868 19.6401 38.7445 18.5519 38.4773 17.4233H21.1006V24.1543H31.3003C31.0947 25.8271 29.9843 28.3462 27.5165 30.0389L27.4819 30.2643L32.9761 34.4354L33.3568 34.4726C36.8526 31.3086 38.868 26.6533 38.868 21.1314Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0995 38.8662C26.0964 38.8662 30.2915 37.2538 33.3556 34.4728L27.5154 30.039C25.9526 31.1072 23.855 31.8528 21.0995 31.8528C16.2052 31.8528 12.0513 28.6889 10.5706 24.3157L10.3535 24.3337L4.64063 28.6667L4.56592 28.8702C7.60937 34.7951 13.8609 38.8662 21.0995 38.8662Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5716 24.3158C10.1809 23.1873 9.95474 21.978 9.95474 20.7286C9.95474 19.479 10.1809 18.2699 10.551 17.1414L10.5407 16.901L4.75614 12.4985L4.56688 12.5868C3.31253 15.0454 2.59277 17.8064 2.59277 20.7286C2.59277 23.6507 3.31253 26.4116 4.56688 28.8703L10.5716 24.3158Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0996 9.60421C24.5748 9.60421 26.9191 11.0754 28.2558 12.3048L33.4791 7.30683C30.2712 4.38468 26.0966 2.59106 21.0996 2.59106C13.8609 2.59106 7.60938 6.66191 4.56592 12.5868L10.5501 17.1414C12.0514 12.7682 16.2053 9.60421 21.0996 9.60421Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.af087b825f4252350327585010cbed75.svg";
export { ForwardRef as ReactComponent };